export const PATH = {
  CHAT: 'chat/:topicId/:userId',
  // CHAT: 'chat/:title',
  FORGOT_PASSWORD: '/forgot-password',
  HOMEPAGE: 'home',
  INFO: 'info',
  LOGIN: 'login',
  MAIN: '/',
  NOTIFICATION: 'notification',
  NOT_FOUND: '*',
  REGISTER: 'register',
  RECOVERY_PASSWORD: '/restore/password',
  SETTINGS: 'settings',
  SUCCESS_SIGNUP: '/activate',
  TOPICS: 'topics',
  VERIFICATION_EMAIL: '/verification-email',
  RESEND_ACTIVATION_EMAIL: '/resend-activation-email',
};
